import React, { useState, useEffect, useContext, useRef } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../../../amplifyconfiguration.json';
import { post } from 'aws-amplify/api';
import { BgImage } from "gbimage-bridge"
import { Container, Row, Col, Label, Form, Input, FormFeedback, FormGroup } from "reactstrap"
import scrollToElement from "scroll-to-element"
import styled from "styled-components"
import { media } from "utils/Media"
import ContainerMax from "components/shared/ContainerMax"
import Button from "components/shared/Button"
import Text from "components/shared/Text"
// import { LinkSearchReplace } from "utils/LinkSearchReplace"
import { LanguageContext } from "utils/LanguageContext"
import {
    validateRequired,
    validateEmail
} from "utils/Validations"
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

Amplify.configure(amplifyconfig);

const ContainerMaxStyled = styled(ContainerMax)`
    color: ${props => props.theme.colors.grey1};   
    padding-top: 3rem;
    padding-bottom: 1.5rem;

    @media ${media.md} {
        padding-top: 4rem;
        padding-bottom: 4rem;
    }

    label {
        font-family: ${props => props.theme.font.family.bold};
        font-size: ${props => props.theme.font.size.sm};
        margin: 0;
    }

    a {
        color: ${props => props.theme.colors.yellow};

        &:hover {
            text-decoration: underline;
        }
    }

    .form-group {
        margin-bottom: 2rem;
    }
`

const Title = styled.h3`
    text-transform: uppercase;
    position: absolute;
    top: -3.7rem;
`

const ContainerStyled = styled(Container)`
    position: relative;
    padding: 2rem;
    padding-top: 2.5rem;
    color: white;

    &:before {
        content: "";
        position: absolute;
        background-image: ${props => props.theme.colors.gradient};
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
`

const ContainerInner = styled.div`
    position: relative;
    z-index: 2;
`

const StyledInput = styled(Input)`
    background-color: transparent;
    color: ${props => props.theme.colors.grey1};
    background-color: ${props => props.theme.colors.white};
    padding: .15rem 1rem;
    width: 100%;
    border: none;
    height: 40px;
    border-radius: 0;
    font-size: ${props => props.theme.font.size.sm};

    &::placeholder {
        color: ${props => props.theme.colors.black};
        font-size: ${props => props.theme.font.size.sm};
    }
`

const FormFeedbackStyled = styled(FormFeedback)`
    color: white;
    position: absolute;
`

const SubmitButton = styled(Button)`
    width: 100%;

    @media ${media.md} {
        margin-top: 1.55rem;
    }

    &.disabled {
        opacity: 1;
        span {
            background-color: ${props => props.theme.colors.pink} !important;
        }
    }
`

const NewsletterSignup = ({ data }) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [state, setState] = useState({
        cd_FIRSTNAME: "",
        email: "",
        website: "", //honeypot field
        validate: {
            email: ''
        },
        required: {
            email: ''
        },
        token: "",
        returnURL: "https://london.tastefestivals.com/thanks-for-signing-up/",
        status: ""
    })
    const formRef = useRef(null)

    const { cd_FIRSTNAME, email, website, validate, required, token, returnURL, status } = state

    const getParameterByName = (name, url = window.location.href) => {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    const handleChange = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;

        let updatedRequired = { ...required }

        if (updatedRequired.hasOwnProperty(name)) {
            updatedRequired[name] = value
        }

        setState(prevState => ({
            ...prevState,
            required: updatedRequired,
            [name]: value,
        }))
    }

    const onSubmit = async (e) => {

        // honeypot check
        if (website !== '') {
            e.preventDefault();
            alert("Thankyou.") // not... its a bot
        }

        var emailAddress = email
        var errorString = '';
        if (emailAddress === '' || emailAddress.indexOf('@') === -1) {
            errorString = 'Please enter your email address';
        }

        if (errorString.length > 0) {
            alert(errorString)
            e.preventDefault()
        }


        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        // Execute reCAPTCHA and get the token
        const token = await executeRecaptcha('submitForm');

        // Send the token to your API Gateway endpoint
        const restOperation = post({
            apiName: 'tasteFestivalLondon',
            path: '/recaptcha',
            options: {
              body: { token },
            }
        });

        const { body } = await restOperation.response;
        const response = await body.json();

        // recaptcha response failed
        if (!response.success) { 
            errorString = 'Please try again';
            alert(errorString)
            e.preventDefault()
        }
    }

    useEffect(() => {
        if (typeof window !== "undefined") {
            const result = getParameterByName('result')

            if (result) {
                const header = document.getElementById('siteHeader')
                let headerHeight = 0
                if (header) {
                    headerHeight = header.offsetHeight
                }

                setState(prevState => ({
                    ...prevState,
                    status: result
                }))

                setTimeout(() => {
                    scrollToElement("#newsletter-signup", {
                        offset: - headerHeight,
                        duration: 500
                    })
                }, 200);
            }
        }
    }, [])

    let sources
    if (data.backgroundImageMobile && data.backgroundImage) {
        sources = [
            getImage(data.backgroundImageMobile.localFile),
            {
                ...getImage(data.backgroundImage.localFile),
                media: `(min-width: 768px)`,
            },
        ]
    }

    return (
        <ContainerMax maxWidth="1920" id="newsletter-signup" noPadding>
            <BgImage image={sources}>
                <ContainerMaxStyled>
                    <ContainerStyled>
                        <ContainerInner>
                            {data.title && 
                                <Title>{data.title}</Title>
                            }
                            {data.text &&
                                <Text as="div" bold dangerouslySetInnerHTML={{ __html: data.text }} className="pb-3" />
                            }
                            <Form 
                                name="signup" 
                                id="signup" 
                                action="https://email-tastefestivals.com/signup.ashx" 
                                method="post" 
                                autoComplete="off" 
                                noValidate
                                onSubmit={(e) => onSubmit(e)}
                                ref={formRef}
                            >
                                <input type="hidden" name="userid" value="97258" />
                                <input type="hidden" name="SIG7ed4001bed9dcf7f636ad69412752832411e644bab2b808f84c9092bfa76edb9" value="" />
                                <input type="hidden" name="addressbookid" value="48973712" />
                                <input 
                                    type="hidden" 
                                    name="ReturnURL" 
                                    value={`${returnURL}`} 
                                />
                                <input type="hidden" id="ci_consenturl" name="ci_consenturl" value="" />
                                <div className="d-none">
                                    <label for="website">Website</label>
                                    <input type="text" id="website" name="website" autocomplete="off" />
                                </div>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col xs={12} md={4} lg={5} className="pb-2 pb-lg-0">
                                                <Label for="FIRSTNAME">FIRST NAME</Label>
                                                <StyledInput
                                                    type="text"
                                                    name="cd_FIRSTNAME"
                                                    id="FIRSTNAME"
                                                    placeholder="Name"
                                                    value={cd_FIRSTNAME}
                                                    onChange={e => {
                                                        handleChange(e)
                                                    }}
                                                />
                                            </Col>
                                            <Col xs={12} md={4} lg={5} className="pb-2 pb-lg-0">
                                                <FormGroup>
                                                    <Label for="EMAIL">EMAIL*</Label>
                                                    <StyledInput
                                                        type="email"
                                                        name="email"
                                                        id="email"
                                                        placeholder="Your email address"
                                                        value={email}
                                                        valid={validate.email === 'has-success'}
                                                        invalid={validate.email === 'has-danger'}
                                                        onChange={e => {
                                                            handleChange(e)  
                                                            validateRequired(e, setState)
                                                            validateEmail(e, setState)                              
                                                        }}
                                                    />
                                                    <FormFeedbackStyled>
                                                        A valid email address is required
                                                    </FormFeedbackStyled>
                                                </FormGroup>
                                            </Col>
                                            <Col xs={12} md={{ order: 1, size: 4 }} lg={2}>  {/*className="d-flex align-items-center"*/}
                                                <SubmitButton 
                                                    as="button" 
                                                    color="secondary" 
                                                    className={`${validate.email === "has-danger" || email === "" ? "disabled" : ""}`}
                                                    disabled={validate.email === "has-danger" || email === ""}
                                                >
                                                    <span>{data.buttonText}</span>
                                                </SubmitButton>
                                            </Col>
                                        </Row>
                                        {(data.successText && status === "success") &&
                                            <Row>
                                                <Col>
                                                    <Text 
                                                        bold
                                                        lg
                                                        dangerouslySetInnerHTML={{ __html: data.successText }} 
                                                        className="pt-3" 
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {status === "error" &&
                                            <Row>
                                                <Col>
                                                    <Text 
                                                        bold
                                                        lg
                                                        className="pt-3" 
                                                    >
                                                        An error occured
                                                    </Text>
                                                </Col>
                                            </Row>
                                        }
                                        {data.termsText && 
                                            <Row>
                                                <Col>
                                                    <Text as="div" sm dangerouslySetInnerHTML={{ __html: data.termsText }} className="pt-3" />
                                                </Col>
                                            </Row>
                                        }
                                    </Col>
                                </Row>       
                            </Form>
                        </ContainerInner>
                    </ContainerStyled>
                </ContainerMaxStyled>
            </BgImage>
        </ContainerMax>
    )
}

const NewsletterSignupExport = () => {
    const { currentLanguage } = useContext(LanguageContext)
    const data = useStaticQuery(graphql`
        query {
            allWp {
                edges {
                    node {
                        ...optionsFragment
                    }
                }
            }
        }
    `)

    if (
        data.allWp.edges[0].node[currentLanguage.code] &&
        data.allWp.edges[0].node[currentLanguage.code].acfOptions.blockNewsletterSignup
    ) {
        return (
            <NewsletterSignup data={data.allWp.edges[0].node[currentLanguage.code].acfOptions.blockNewsletterSignup} />
        )
    } else {
        return null
    }
}

export default NewsletterSignupExport